import { jsx, Fragment } from 'react/jsx-runtime';
import { useContext } from 'react';
import { Tooltip } from '../../Tooltip/Tooltip.es.js';
import { SidenavContext } from '../Sidenav.Context/Sidenav.Context.es.js';

const SidenavItemTooltip = ({ content, children })=>{
    const { collapsed } = useContext(SidenavContext);
    if (!collapsed) {
        return jsx(Fragment, {
            children: children
        });
    }
    return jsx(Tooltip, {
        content: content,
        place: "right",
        width: "hug",
        children: children
    });
};

export { SidenavItemTooltip };
//# sourceMappingURL=Sidenav.Item.Tooltip.es.js.map
